// AI Generated Test
import { Component, Input } from '@angular/core';

@Component({
    selector: 'seo-information-missing-meta-description',
    standalone: false,
    template: `
        <h5 translate>There is no META descriptions on this page</h5>
    `,
})
export class SeoInformationMissingMetaDescriptionComponent {
    @Input() seo: any;
}
